import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowClockwise, WarningCircle } from "@phosphor-icons/react";
import { fmtDate } from "./designsApi";

export const DesignFailedList = ({ rows, onRetry, onRetryAll, busy }) => (
  <div className="rounded-sm border border-red-500/30 overflow-hidden" data-testid="designs-failed-list">
    <div className="flex items-center justify-between px-4 py-2 bg-red-500/5 border-b border-red-500/30">
      <div className="text-xs tracking-widest text-red-300 font-mono-num flex items-center gap-2">
        <WarningCircle size={14} /> FAILED FILES ({rows.length})
      </div>
      {rows.length > 0 && (
        <Button size="sm" variant="outline" disabled={busy} onClick={onRetryAll}
          className="rounded-sm border-slate-700 bg-slate-950 h-8" data-testid="designs-retry-all">
          <ArrowClockwise size={14} className="mr-1" /> RETRY ALL
        </Button>
      )}
    </div>
    {rows.length === 0 ? (
      <div className="p-6 text-center text-slate-400 text-sm">Koi failed file nahi.</div>
    ) : rows.map((r) => (
      <div key={r.id} className="flex flex-wrap items-center gap-3 px-4 py-3 border-b border-slate-800 last:border-b-0 text-sm"
        data-testid={`designs-failed-row-${r.id}`}>
        <div className="font-mono-num text-orange-300 w-32 shrink-0">#{r.order_number}</div>
        <div className="flex-1 min-w-[180px]">
          <div className="text-slate-100 break-all">{r.original_filename || "(file naam nahi)"}</div>
          <div className="text-xs text-red-300 break-all">
            {r.status === "invalid" && <span className="mr-1 px-1 rounded-sm bg-slate-800 text-slate-300">DXF NAHI · LIBRARY SE BAHAR</span>}
            {r.error}{r.attempts ? ` · ${r.attempts} baar try` : ""}
          </div>
          <div className="text-[11px] text-slate-500">{r.customer_name} · {fmtDate(r.order_date)}</div>
        </div>
        {r.status !== "invalid" && <Button size="sm" variant="outline" disabled={busy} onClick={() => onRetry(r.id)}
          className="rounded-sm border-slate-700 bg-slate-950 h-8" data-testid={`designs-retry-${r.id}`}>
          RETRY
        </Button>}
      </div>
    ))}
  </div>
);
